// extracted by mini-css-extract-plugin
module.exports = {"container":"RnkimContent_container__3KMc0","frame":"RnkimContent_frame__3YH9J","spin":"RnkimContent_spin__3-KR5"};